import React from 'react';
import { RefreshCw, Sparkles } from 'lucide-react';
import { Button } from '../ui/Button';
import { Skeleton } from '../ui/Skeleton';
import { dailyBriefSets } from '../../data/insights';
import { useAiRun } from '../../hooks/useAiRun';
const RUN_STAGES = ['Reading portfolio state', 'Comparing against historical outcomes', 'Drafting insight summary'];
const toneClasses: Record<string, string> = {
  positive: 'text-[#7fe0b6]',
  watch: 'text-[#f0c94f]',
  risk: 'text-[#ff9d9b]'
};
export function AiDailyBrief() {
  const [setIndex, setSetIndex] = React.useState(0);
  const run = useAiRun({
    stages: RUN_STAGES,
    stageDuration: 650
  });
  const insights = dailyBriefSets[setIndex % dailyBriefSets.length];
  React.useEffect(() => {
    if (run.state === 'complete') {
      setSetIndex(index => index + 1);
      run.reset();
    }
  }, [run]);
  const running = run.state === 'running';
  return <section className="rounded-sm border-l-4 border-uae-gold bg-uae-navy p-4 text-white" data-id="element-28" data-mp="180b5pxz3dm0q">
      <div className="flex items-start justify-between gap-3" data-id="element-29" data-mp="14nx2n0x9gez8">
        <div data-id="element-30" data-mp="14lkm8s75icoa">
          <h2 className="flex items-center gap-1.5 text-[13px] font-semibold" data-id="element-31" data-mp="19mi22y4ouumm">
            <Sparkles className="h-4 w-4" aria-hidden="true" data-id="element-32" data-mp="19kdsbzk3z1ef" />
            AI daily brief
          </h2>
          <p className="mt-1 text-[11px] text-white/55" data-id="element-33" data-mp="1efkngizbaxrq">
            Generated across the live pipeline, gates and outreach delivery
          </p>
        </div>
        <Button variant="ghost" size="xs" onClick={run.start} disabled={running} className="text-white/75 hover:bg-white/10 hover:text-white" data-id="element-34" data-mp="lpuhix7u326p">
          <RefreshCw className={`mr-1 h-3 w-3 ${running ? 'animate-spin' : ''}`} aria-hidden="true" data-id="element-35" data-mp="uofumcujdp03" />
          {running ? 'Generating' : 'Regenerate'}
        </Button>
      </div>

      {running ? <div className="mt-4 space-y-3" aria-live="polite" data-id="element-36" data-mp="266qqb76f39kp">
          {[0, 1, 2].map(index => <div key={index} className="rounded-sm bg-white/5 p-3" data-id="element-37" data-mp="2b5ag5io4t5ic">
              <Skeleton className="h-3 w-2/3 bg-white/10" data-id="element-38" data-mp="azn1uh8z2jpb" />
              <Skeleton className="mt-2 h-3 w-full bg-white/10" data-id="element-39" data-mp="705vlllq1ij3" />
              <Skeleton className="mt-1.5 h-3 w-4/5 bg-white/10" data-id="element-40" data-mp="71z1gyoifyq1" />
            </div>)}
          <p className="text-[11px] text-white/60" data-id="element-41" data-mp="kx1hwfqzh6h3">{run.currentStage}…</p>
        </div> : <ul className="mt-4 space-y-2.5" data-id="element-42" data-mp="fyhtm8ox3ilk">
          {insights.map(insight => <li key={insight.id} className="rounded-sm bg-white/5 p-3" data-id="element-43" data-mp="3ogdxt0wxib46">
              <div className="flex items-start justify-between gap-3" data-id="element-44" data-mp="3jicgakf5ijut">
                <p className="text-[12px] font-medium leading-snug text-white" data-id="element-45" data-mp="211msw2plmta">
                  <span className={`mr-1.5 ${toneClasses[insight.tone]}`} aria-hidden="true" data-id="element-46" data-mp="3tf7fl5j90oa5">
                    ●
                  </span>
                  {insight.label}
                </p>
                <span className="shrink-0 font-mono text-[10px] text-white/50" data-id="element-47" data-mp="30qjmwow66wmk">
                  {insight.confidence}%
                </span>
              </div>
              <p className="mt-1.5 text-[11px] leading-relaxed text-white/60" data-id="element-48" data-mp="1g6y2b34pcawx">{insight.detail}</p>
            </li>)}
        </ul>}
    </section>;
}